import cookieParser from 'cookie';
import setCookieParser from 'set-cookie-parser';
import keyBy from 'utils/keyBy';

export default class CookieProxy {
  apiRequestCookies = [];

  apiResponseSetCookieHeaders = [];

  constructor(request) {
    this.storeClientRequestCookies(request);
  }

  storeClientRequestCookies(request) {
    const cookieHeader = request.get('Cookie') || '';
    const cookies = cookieParser.parse(cookieHeader);
    this.apiRequestCookies = Object.keys(cookies).map(name => ({ name, value: encodeURI(cookies[name]) }));
  }

  storeApiResponseCookies(response) {
    const setCookieHeaders = response.headers.raw()['set-cookie'] || [];

    this.apiResponseSetCookieHeaders = setCookieHeaders;
    const mergedCookies = {
      ...keyBy(this.apiRequestCookies, 'name'),
      ...keyBy(setCookieParser.parse(setCookieHeaders), 'name'),
    };

    this.apiRequestCookies = Object.values(mergedCookies);
  }

  formatCookiesForApiRequest() {
    return this.apiRequestCookies.map(cookie => `${cookie.name}=${cookie.value}`).join('; ');
  }

  getApiResponseSetCookieHeaders() {
    return this.apiResponseSetCookieHeaders;
  }
}
